"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_1 = require("@bhtp-client-api/base");
var rules_model_1 = require("./models/rules.model");
var traveler_detail_config_model_1 = require("./models/traveler-detail-config.model");
var policy_config_model_1 = require("./models/policy-config.model");
var field_rules_model_1 = require("./models/field-rules.model");
var constraint_rules_model_1 = require("./models/constraint-rules.model");
var min_max_constraint_model_1 = require("./models/min-max-constraint.model");
var select_item_model_1 = require("./models/select-item.model");
var BhtpRulesService = (function (_super) {
    __extends(BhtpRulesService, _super);
    function BhtpRulesService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    BhtpRulesService.prototype.getPolicyRulesets = function (ratingId, state, effectiveDate) {
        var _this = this;
        if (state === void 0) { state = null; }
        if (effectiveDate === void 0) { effectiveDate = null; }
        var endpoint = this.getRulesEndpoint(ratingId, state, effectiveDate);
        var path = this.getFullUrl(endpoint);
        var options = this.getStandardRequestOptions();
        return this.http.get(path, options)
            .map(function (data) {
            var rules = data.json();
            return rules;
        })
            .map(function (rules) {
            return _this.mapResponseToRules(rules);
        });
    };
    BhtpRulesService.prototype.mapResponseToRules = function (rules) {
        var mappedRules = new rules_model_1.Rules();
        mappedRules.fields = new field_rules_model_1.FieldRules();
        mappedRules.fields.policyHolder = this.mapTravelerFields(rules.fields.policyholder);
        mappedRules.fields.policyHolder.tripCost = this.getMappedRulesFields(rules.fields.policy.tripCost);
        mappedRules.fields.additionalTraveler = this.mapTravelerFields(rules.fields.additionalTraveler);
        mappedRules.fields.additionalTraveler.tripCost = this.getMappedRulesFields(rules.fields.policy.tripCost);
        mappedRules.fields.policy = this.mapPolicyFields(rules.fields.policy);
        mappedRules.constraints = this.mapConstraintFields(rules.constraints);
        mappedRules.constraints.relationshipDescriptions = this.mapRelationships(rules.constraints.relationshipDescriptions);
        return mappedRules;
    };
    BhtpRulesService.prototype.mapTravelerFields = function (rules) {
        if (rules) {
            var travelerBase = new traveler_detail_config_model_1.TravelerDetailConfig();
            travelerBase.firstName = this.getMappedRulesFields(rules.firstName);
            travelerBase.lastName = this.getMappedRulesFields(rules.lastName);
            travelerBase.birthdate = this.getMappedRulesFields(rules.birthdate);
            travelerBase.email = this.getMappedRulesFields(rules.email);
            travelerBase.phoneNumber = this.getMappedRulesFields(rules.phoneNumber);
            travelerBase.address = this.getMappedRulesFields(rules.address);
            travelerBase.relationshipToPolicyholder = this.getMappedRulesFields(rules.relationshipToPolicyholder);
            travelerBase.gender = this.getMappedRulesFields(rules.gender);
            return travelerBase;
        }
        return null;
    };
    BhtpRulesService.prototype.mapPolicyFields = function (rules) {
        if (rules) {
            var policyConfig = new policy_config_model_1.PolicyConfig();
            policyConfig.airline = this.getMappedRulesFields(rules.airline);
            policyConfig.carRentalCompany = this.getMappedRulesFields(rules.carRentalCompany);
            policyConfig.cruiseLine = this.getMappedRulesFields(rules.cruiseLine);
            policyConfig.depositDate = this.getMappedRulesFields(rules.initialTripDepositDate);
            policyConfig.destination = this.getMappedRulesFields(rules.destination);
            policyConfig.flights = this.getMappedRulesFields(rules.flights);
            policyConfig.hotel = this.getMappedRulesFields(rules.hotel);
            policyConfig.rentalCompany = this.getMappedRulesFields(rules.rentalCompany);
            policyConfig.state = this.getMappedRulesFields(rules.state);
            policyConfig.tourOperator = this.getMappedRulesFields(rules.tourOperator);
            policyConfig.tripCost = this.getMappedRulesFields(rules.tripCost);
            policyConfig.tripDates = this.getMappedRulesFields(rules.tripDates);
            return policyConfig;
        }
        return null;
    };
    BhtpRulesService.prototype.getMappedRulesFields = function (rules) {
        if (rules) {
            if (rules.overrides) {
                throw new Error('Rule overrides not implemented');
            }
            return {
                required: rules.base.indexOf('r') > -1,
                editable: rules.base.indexOf('e') > -1,
                show: true
            };
        }
        return {
            required: false,
            editable: false,
            show: false
        };
    };
    BhtpRulesService.prototype.mapConstraintFields = function (constraints) {
        if (constraints) {
            var constraintRules = new constraint_rules_model_1.ConstraintRules();
            if (constraints.minimumAge && constraints.maximumAge) {
                constraintRules.age = new min_max_constraint_model_1.MinMaxConstraint(constraints.minimumAge.base, constraints.maximumAge.base);
            }
            if (constraints.minTravelersPerPolicy && constraints.maxTravelersPerPolicy) {
                constraintRules.travelersPerPolicy = new min_max_constraint_model_1.MinMaxConstraint(constraints.minTravelersPerPolicy.base, constraints.maxTravelersPerPolicy.base);
            }
            if (constraints.minimumTripCost || constraints.maximumTripCost) {
                constraintRules.tripCost = new min_max_constraint_model_1.MinMaxConstraint(getBaseOrNull(constraints.minimumTripCost) || 0, getBaseOrNull(constraints.maximumTripCost));
            }
            if (constraints.minimumTripLength || constraints.maximumTripLength) {
                constraintRules.tripLength = new min_max_constraint_model_1.MinMaxConstraint(getBaseOrNull(constraints.minimumTripLength), getBaseOrNull(constraints.maximumTripLength));
            }
            return constraintRules;
        }
        return null;
        function getBaseOrNull(rule) {
            if (rule) {
                return rule.base;
            }
            else {
                return null;
            }
        }
    };
    BhtpRulesService.prototype.mapRelationships = function (relationships) {
        if (relationships) {
            var relationshipItems_1 = [];
            relationships.forEach(function (item) {
                relationshipItems_1.push(new select_item_model_1.SelectItem(item.key, item.displayValue, item.canSelect.base));
            });
            return relationshipItems_1;
        }
        return null;
    };
    BhtpRulesService.prototype.getRulesEndpoint = function (ratingId, state, effectiveDate) {
        if (state === void 0) { state = null; }
        if (effectiveDate === void 0) { effectiveDate = null; }
        var endpoint = '/Rules' + (state ? "/" + state : '') + ("?ratingId=" + ratingId);
        if (effectiveDate) {
            endpoint += "&effectiveDate=" + effectiveDate;
        }
        return endpoint;
    };
    return BhtpRulesService;
}(base_1.BhtpBaseService));
BhtpRulesService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BhtpRulesService);
exports.BhtpRulesService = BhtpRulesService;
//# sourceMappingURL=D:/a/1/s/eligibility/src/rules/rules.service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/rules/rules.service.js